export default __webpack_public_path__ + "static/media/SocialMedia.ea00ad6e.png";